import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { apiBaseUrl } from "@/api/service";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-company",
  data: function data() {
    return {
      apiBaseUrl: apiBaseUrl,
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        phone: this.$route.query.phone,
        no: this.$route.query.id,
        status: 0
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数
      importLoading: false,
      cityList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getCityList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getCityList: function getCityList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getCityListByPy();
            case 1:
              res = _context2.v;
              _this2.cityList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pageNum = 1;
                _this3.searchForm.pageSize = 20;
              }
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.findAllBrandQuarter(_this3.searchForm);
            case 1:
              res = _context3.v;
              res.data.list.forEach(function (item) {
                var user = JSON.parse(JSON.stringify(item.user));
                if (user) {
                  item.user = {
                    id: user.id,
                    avatar: user.avatar,
                    phone: user.phone,
                    name: user.name,
                    remark: user.remark,
                    disable_send_msg_at: user.disableSendMsgAt,
                    user_type: user.userType,
                    user_type_status: user.userTypeStatus,
                    user_type_account_status: user.userTypeAccountStatus,
                    landlord_status: user.landlordStatus,
                    tenant_status: user.tenantStatus,
                    scene: user.scene
                  };
                } else {
                  item.user = {};
                }
              });
              _this3.tableData = res.data.list;
              _this3.total = res.data.totalCount;
              _this3.tableLoading = false;
              _this3.getUserListByIds(_this3.tableData, "userId");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    uploadSuccess: function uploadSuccess(res, file, fileList) {
      if (res.code == 200) {
        this.$refs.uploader.clearFiles();
      } else {
        this.$message.error(res.msg);
      }
    },
    uploadError: function uploadError(err, file, fileList) {
      this.importLoading = false;
      this.$refs.uploader.clearFiles();
    },
    uploadProgress: function uploadProgress(event, file, fileList) {
      // console.log(event, file, fileList)
    },
    uploadChange: function uploadChange(file, fileList) {
      if (file.response && file.response.code == 200) {
        this.importLoading = false;
        this.$message.success(file.response.msg);
        this.pageChange(1);
      } else {
        this.importLoading = true;
      }
    }
  }
};